/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsListAccountsApiV1LedgersLedgerCanisterIdAccountsGet } from "../../funcs/accountsListAccountsApiV1LedgersLedgerCanisterIdAccountsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema,
};

export const tool$accountsListAccountsApiV1LedgersLedgerCanisterIdAccountsGet:
  ToolDefinition<typeof args> = {
    name: "accounts-list-v1",
    description: `Original tool name: accounts-list-accounts-api-v1-ledgers-ledger-canister-id-accounts-get

List accounts

### How is data retrieved for this endpoint?

Values from the endpoint are created by the retrieved transactions from the
ledger canister. As transactions come in, the API updates the account information
and balances in the database.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountsListAccountsApiV1LedgersLedgerCanisterIdAccountsGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };